import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import FloatingWhatsApp from "./components/site/FloatingWhatsApp";

import Home from "./pages/Home";
import About from "./pages/About";
import { ArtistsList, ArtistDetail } from "./pages/Artists";
import Videos from "./pages/Videos";
import Events from "./pages/Events";
import Shop from "./pages/Shop";
import Membership from "./pages/Membership";
import ArtistDevelopment from "./pages/ArtistDevelopment";
import Donate from "./pages/Donate";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import MemberDashboard from "./pages/MemberDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import { PaymentSuccess } from "./pages/PaymentSuccess";
import AuthCallback from "./pages/AuthCallback";
import EventStream from "./pages/EventStream";
import EventPhotos from "./pages/EventPhotos";
import EventDetail from "./pages/EventDetail";
import AnalyticsInjector from "./components/site/AnalyticsInjector";

function AppShell() {
  const location = useLocation();

  // Handle Emergent OAuth callback early (fragment has session_id)
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const isFullBleed = ["/login"].includes(location.pathname);

  return (
    <>
      {!isFullBleed && <Navbar />}
      <main>
        <AnalyticsInjector />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/artists" element={<ArtistsList />} />
          <Route path="/artists/:id" element={<ArtistDetail />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id/photos" element={<EventPhotos />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/artist-development" element={<ArtistDevelopment />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<MemberDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/events/:id/stream" element={<EventStream />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isFullBleed && <Footer />}
      {!isFullBleed && <FloatingWhatsApp />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
